import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/Billing/AddBilling.module.scss";
import Pagination from "../../Components/Common/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetMyBillViewQuery } from "../../slices/admin/admin";

const ViewMyBilling = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const { data, isLoading, isError } = useGetMyBillViewQuery(id);

  useEffect(() => {
    setCurrentPage(1);
  }, [limit]);

  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>Something went wrong</p>;
  if (!data || !data.data || data.data.length === 0)
    return <p>No Data Found</p>;

  console.log("Bill View Data:", data);
  const bill = data.data[0];

  const customerName = bill?.createdBy?.firstName || "N/A";
  const customerPhone = bill?.createdBy?.phone || "N/A";

  const capitalizeWords = (str = "") =>
    str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const logisticsName = bill?.logisticStore?.storeName
    ? capitalizeWords(bill.logisticStore.storeName)
    : capitalizeWords(
        `${bill?.logisticId?.firstName || ""} ${
          bill?.logisticId?.lastName || ""
        }`.trim()
      ) || "N/A";

  const handleCharge = bill?.handleCharge || 0;
  const logisticCharge = bill?.logisticCharge || 0;
  const paymentMethod = bill?.paymentMethod || "N/A";

  const items = bill?.items || [];

  const totalAmount =
    items.reduce((sum, it) => sum + (it.totalPrice || 0), 0) +
    handleCharge +
    logisticCharge;

  // pagination logic
  const totalPages = Math.ceil(items.length / limit);
  const paginatedItems = items.slice(
    (currentPage - 1) * limit,
    currentPage * limit
  );

  return (
    <div className={styles.billingContainer}>
      <div className={styles.header}>
        <h2 className={styles.tittle}>View Billing</h2>
        <span
          className={styles.closeIcon}
          onClick={() => navigate("/dashboard/billing")}
        >
          ✕
        </span>
      </div>

      <div className={styles.billingContainers}>
        <div className={styles.formSection}>
          <div className={styles.ownerBoxxx}>
            <p>
              <strong>Item Owner :</strong> {customerName}
            </p>
            <p>
              <strong>Phone No :</strong> {customerPhone}
            </p>
          </div>
        </div>

        <div className={styles.itemsHeader}>
          <h4>Items</h4>
        </div>

        {/* Items Table */}
        <div className={styles.itemsSection}>
          <div className={styles.tableWrapper}>
            <table>
              <thead>
                <tr>
                  <th>Item Category</th>
                  <th>Price</th>
                  <th>Item Quantity</th>
                  <th>Total Price</th>
                </tr>
              </thead>

              <tbody>
                {paginatedItems.map((item, index) => (
                  <tr key={item._id || index}>
                    <td>{item.productName}</td>
                    <td>₹{item.price}</td>
                    <td>{item.productQuantity}</td>
                    <td>₹{item.totalPrice}</td>
                  </tr>
                ))}

                {paginatedItems.length === 0 && (
                  <tr>
                    <td
                      colSpan={4}
                      className={styles.noData}
                      style={{ textAlign: "center" }}
                    >
                      No items found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className={styles.paginationWrapper}>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />

            <select
              className={styles.inputsbtn}
              value={limit}
              onChange={(e) => setLimit(Number(e.target.value))}
            >
              <option value={10}>10 rows</option>
              <option value={25}>25 rows</option>
              <option value={50}>50 rows</option>
            </select>
          </div>
        </div>

        {/* Billing Summary */}
        <div className={styles.totalSection}>
          <div className={styles.amountDetails}>
            <div className={styles.paddingsec}>
              <div className={styles.dflex}>
                <label className={styles.inputLabels}>
                  Transpor tName :{" "}
                </label>
                <div className={styles.inputGroup}>
                  <h6 className={styles.inputlast}>{logisticsName}</h6>
                </div>
              </div>
            </div>

            <div className={styles.paddingsec}>
              <div className={styles.dflex}>
                <div>
                  <label className={styles.inputLabels}>
                    Handling Charge :{" "}
                  </label>
                </div>
                <p className={styles.inputlast}>₹ {handleCharge}</p>
              </div>

              <div className={styles.dflex}>
                <div>
                  <label className={styles.inputLabels}>
                    Transport Amount :{" "}
                  </label>
                </div>
                <p className={styles.inputlast}>₹ {logisticCharge}</p>
              </div>

              <div className={styles.dflex}>
                <div>
                  <p>
                    <strong>Total Amount : </strong>
                  </p>
                </div>
                <p className={styles.inputlast}>₹ {totalAmount}</p>
              </div>
            </div>
          </div>

          <hr />

          <div className={styles.headpaymentss}>
            <div className={styles.emptydiv}></div>
            <div className={styles.widthone}>
              <div className={styles.final}>
                <label className={styles.inputLabels}>
                  Payment Type :{" "}
                </label>
              </div>
              <h6 className={styles.inputlast}>{paymentMethod}</h6>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className={styles.footerButtons}>
          <button
            className={styles.cancelBtn}
            onClick={() => navigate("/dashboard/billing")}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewMyBilling;




